import api from "config/api";
import React, { useEffect, useState } from "react";
import noImage from "assets/images/no-image.png";
import Button from "components/common/Button";
import EditDepartmentDialog from "components/admin/EditDepartmentDialog";

type Props = {};

const Item = ({ item, onClick }: any) => {
  const [loading, setLoading] = useState<any>();
  return (
    <div className="w-full border border-gray-200 rounded-3xl shadow-lg p-3 flex gap-3">
      <div className="pl-1 max-w-[40%] w-full">
        {loading && (
          <div className="flex justify-center items-center w-full h-auto min-h-[100px] min-w-[100px] max-h-[200px] max-w-[200px] md:max-h-[250px] md:max-w-[250px] lg:max-h-[300px] lg:max-w-[300px] aspect-square rounded-3xl  object-cover border-4 border-gray-300 ">
            <div className="w-10 h-10  border-4 border-gray-300 border-t-primary rounded-full animate-spin"></div>
          </div>
        )}

        <img
          src={item.imageUrl || noImage}
          className={`w-full h-auto min-h-[100px] min-w-[100px] max-h-[200px] max-w-[200px] md:max-h-[250px] md:max-w-[250px] lg:max-h-[300px] lg:max-w-[300px] aspect-square rounded-2xl object-cover ${
            loading ? "hidden" : "block"
          }`}
          onLoad={() => setLoading(false)}
          onError={(e) => {
            e.currentTarget.src = noImage;
            setLoading(false);
          }}
          alt=""
        />
      </div>
      <div className="flex flex-col justify-between flex-1">
        <h3 className="font-bold text-lg mb-1 text-itemColor line-clamp-2">
          {item.categoryDescription}
        </h3>
        <Button className="self-end" onClick={onClick}>
          Update
        </Button>
      </div>
    </div>
  );
};
const DepartmentList = (props: Props) => {
  const [list, setList] = useState([]);
  const [updateItem, setUpdateItem] = useState<any>(undefined);

  const fetchNewData = () => {
    api
      .get("/api/initialData")
      .then(({ data }) => {
        setList(data.categories);
      })
      .catch((e) => {
        console.error("Failed to load /api/initialData for departments", e);
      });
  };

  useEffect(() => {
    fetchNewData();
  }, []);

  return (
    <div className="w-full flex justify-center items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3 overflow-y-auto max-h-full p-4 w-full ">
        {list.map((item) => (
          <Item item={item} onClick={() => setUpdateItem(item)} />
        ))}
      </div>
      <EditDepartmentDialog
        selected={updateItem}
        setSelected={setUpdateItem}
        onComplete={() => fetchNewData()}
      />
    </div>
  );
};

export default DepartmentList;
